import React from 'react'
import Accordion from 'react-bootstrap/Accordion'
import { ImgWrapper, Img, AccordionDiv} from './AccordionElements'
import Img1 from '../../images/mendoza-4.png'
import './style.css'


const AccordionSection = () => {
  return (
  <AccordionDiv id='planes'>
            <Accordion  flush className="accordion">
        <Accordion.Item eventKey="0" className="accordion-item" >
            <Accordion.Header className="accordion-header" >Accordion Item #1</Accordion.Header>
            <Accordion.Body classNAme="accordion-body">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
            veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
            commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
            velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
            cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
            est laborum.
            </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1" className="accordion-item">
            <Accordion.Header>Accordion Item #2</Accordion.Header>
            <Accordion.Body>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
            veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
            commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
            velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
            cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
            est laborum.
            </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2" className="accordion-item">
            <Accordion.Header>Accordion Item #3</Accordion.Header>
            <Accordion.Body>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
            veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
            commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
            velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
            cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
            est laborum.
            </Accordion.Body>
        </Accordion.Item>
        </Accordion>
        <ImgWrapper>
        <Img src={Img1}/>
        </ImgWrapper>
</AccordionDiv>

      

  )
}

export default AccordionSection